/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
function updateSubscriptionBadge() {
  if (__st.rtyp === 'product') {
    console.log('updateSubscriptionBadge');
    let intervalId = setInterval(() => {
      if (document.querySelector('.appstle-save-badge')) {
        document.querySelector('.appstle-save-badge').innerText = 'SAVE 40% OFF + FREE GIFTS';
        clearInterval(intervalId);
        console.log("Counter stopped.");
      }
    }, 100);
  }
}


$(document).ready(function(){
  updateSubscriptionBadge()
     $(document).on("click", ".product-video_review .review-tab-inner:not(.review-video-slider) .video-control", function() {
       var clickedControl = $(this);
       var clickedVideo = clickedControl.closest('.popup-video').find('video')[0];
       var videoHtml = clickedControl.closest('.video-item').html();

       // Move the video to the main popup
       $('.review-main-popup').html(videoHtml);

       // Pause all other videos
       $('.popup-video video').not(clickedVideo).each(function() {
           this.pause();
           $(this).siblings('.video-control').removeClass('btnhide');
       });

       // Toggle play/pause and update control icon for the video in the main popup
       var mainPopupVideo = $('.review-main-popup video')[0];
       
       if (mainPopupVideo.paused) {
           mainPopupVideo.play();
           $('.review-main-popup .video-control').addClass('btnhide');
       } else {
           mainPopupVideo.pause();
           $('.review-main-popup .video-control').removeClass('btnhide');
       }

       // Activate the main popup
       $('.review-main-popup').addClass('video-active');
       $('body').addClass('video-popup-active');
   });

     $(document).on("click", ".review-main-popup .icon-close", function() {
       // Pause and close the video in the main popup
       var mainPopupVideo = $('.review-main-popup video')[0];
       if (mainPopupVideo) {
           mainPopupVideo.pause();
           $('.review-main-popup .video-control').removeClass('btnhide');
       }

       $('body').removeClass('video-popup-active');
       $('.review-main-popup').removeClass('video-active');
       $('.review-main-popup').empty();
  });
   $('body').click(function(e) {
     var mainPopupVideo = $('.review-main-popup video')[0];
       if (mainPopupVideo) {
           mainPopupVideo.pause();
           $('.review-main-popup .video-control').removeClass('btnhide');
       }

       $('body').removeClass('video-popup-active');
       $('.review-main-popup').removeClass('video-active');
       $('.review-main-popup').empty();
})
   $(document).on("click", ".review-main-popup .icon-volume", function() {
    var mainPopupVideo = $(this).parents('.review-main-popup').find('video')[0];
   	if (mainPopupVideo) {
   		mainPopupVideo.muted = !mainPopupVideo.muted;
   		$(this).toggleClass("volume-muted", mainPopupVideo.muted);
   	}
   });

  // Review Video Slider V2
  $(document).on("click", ".review-tab-inner.review-video-slider video", function() {
    var sliderVideo = $(this)[0];
    if (sliderVideo.paused) {
         sliderVideo.play();
         $(this).siblings('.video-control').addClass('btnhide');
     } else {
         sliderVideo.pause();
         $(this).siblings('.video-control').removeClass('btnhide');
     }
  });

  $('.reviews-main-block .reviews-slider').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    appendDots: $('.reviews-slider-controls .control-dots'),
    prevArrow: $('.reviews-slider-controls .arrow-prev'),
    nextArrow: $('.reviews-slider-controls .arrow-next'),
    responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        
      }
    }
  ]
  });
  
  $('.review-video-slider').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    
    // appendDots: $('.reviews-slider-controls .control-dots'),
    // prevArrow: $('<span class=""'),
    // nextArrow: $('.reviews-slider-controls .arrow-next'),
    responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
  });


    if($('.reviews-slider .slick-slide').length <= 3){
      $('.reviews-slider-controls').addClass('hidden');
    }
    else{
      $('.reviews-slider-controls').removeClass('hidden');
    }
});


// homepage video sider


 $('.custom-index-video-slider .review-tab-inner').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows:false,
    centerMode: true,
    centerPadding: '150px',
     responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '80px',
        }
      },
        {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '50px',
        }
      }
    ]
});


// end of homepage video sider

/* -------------------- one time bar -------------------*/


/* ---------------- Currency format ---------*/
Shopify.formatMoney = function(cents, format) {
      if (typeof cents == 'string') {
      cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /{{\s*(\w+)\s*}}/;
      var formatString = (format || this.money_format);
      function defaultOption(opt, def) {
          return (typeof opt == 'undefined' ? def : opt);
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ',');
          decimal = defaultOption(decimal, '.');
          if (isNaN(number) || number == null) {
              return 0;
          }
          number = (number / 100.0).toFixed(precision);
          var parts = number.split('.'),
              dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              cents = parts[1] ? (decimal + parts[1]) : '';
          return dollars + cents;
      }
      switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
              value = formatWithDelimiters(cents, 2);
              break;
          case 'amount_no_decimals':
              value = formatWithDelimiters(cents, 0);
              break;
          case 'amount_with_comma_separator':
              value = formatWithDelimiters(cents, 2, '.', ',');
              break;
          case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(cents, 0, '.', ',');
              break;
      }
      return formatString.replace(placeholderRegex, value);
      };

   const timeInterval = setInterval(function(){
    let oneTimeContainer = $('.appstle_one_time_description_text');
    if(oneTimeContainer.length > 0){
      let createContainer =  $('.onetime_bar_container');
      $(createContainer).insertAfter(oneTimeContainer);
      clearInterval(timeInterval)
    }
   
  },100);
/* ---------------------- end of Currency format ------------------- */

/* ----------------- Get cart ------------------------------ */

async function fetchCart() {
  let response = await fetch('/cart.js');
  let cart = await response.json();

  const FREE_GIFT_PRODUCT_IDS = [7513048514637,7513047990349,7513047269453]; 

  let barAmount = Number($('.onetime_bar_container').data('bar-amount'));
  let realItemCount = 0;

 
  cart.items.forEach(item => {
    if (!FREE_GIFT_PRODUCT_IDS.includes(item.product_id)) {
      realItemCount += item.quantity;
    }
  });
 let progressPercent = (realItemCount * 100) / barAmount;
  if (progressPercent > 100) progressPercent = 100;

  $('.one_time_bar').css('width', `${progressPercent}%`);

  // Update progress bar message
  if (realItemCount <= 0) {
    $('.bar_discount_amount').text(`Add 2 more products to unlock 15% discount`);
  } else if (realItemCount === 1) {
    $('.bar_discount_amount').text(`Add 1 more product to your cart to unlock 15% off.`);
  } else if (realItemCount >= 2) {
    $('.bar_discount_amount').text(`You've unlocked 15% OFF your entire order! Discount applied in cart.`);
  }
}

/* ------------ end of get cart ----------------------- */

/* when Product add to cart*/
 document.addEventListener('product:added', function(event) {
  fetchCart();
 });
/*--------- end of product add to cart ----------------*/


/* ------------------ when variant change ---------------- */
document.addEventListener('variant:changed', function(event) {
 
  let barAmount = $('body').data('bar-amount');
   setTimeout(function(){
     $('.onetime_bar_container').remove();
     const container = document.createElement('div');
      container.className = 'onetime_bar_container';
      container.setAttribute('data-bar-amount', barAmount); 
      const innerBarContent = document.createElement('div');
      innerBarContent.className = 'inner_bar_content';
      const oneTimeBar = document.createElement('div');
      oneTimeBar.className = 'one_time_bar';
      const barDot = document.createElement('div');
      barDot.className = 'bar-dot';
      oneTimeBar.appendChild(barDot);
      innerBarContent.appendChild(oneTimeBar);
      const barDiscount = document.createElement('div');
      barDiscount.className = 'bar_discount_amount';
      barDiscount.textContent = '';
      container.appendChild(innerBarContent);
      container.appendChild(barDiscount);
      $(container).insertAfter('.appstle_one_time_description_text');
      fetchCart()
  },800);

  });

/* ---------------- end variant change --------------------------- */


/* ---------------- when drawer update --------------- */

/* ------------------ end drawer update ------------------ */




// custom-quick-add
$('.custom-quickadd-button button').click(function(e){
    e.preventDefault();
    let variant_id = $(this).data('variant-id');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: variant_id
        },
          dataType: 'json', 
         success: function (data) { 
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: variant_id,
                quantity:  1
              }
            }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
           bubbles: true
          }));
          } 
        }) 
});
$(document).on('click', '.custom_upsell_add', function(e){
     e.preventDefault();
    let variant_id = $(this).data('variant-id');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: variant_id
        },
          dataType: 'json', 
         success: function (data) { 
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: variant_id,
                quantity:  1
              }
            }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
           bubbles: true
          }));
          } 
        }) 
});

// sticky add to cart
$('.sticky-add-to-cart').click(function(e){
    e.preventDefault();
    let variant_id = $(this).data('variant_id');
    let selling_id = $(this).data('selling-plan-id');
    let cart_button =  $(this).closest('.template-product').find('.Product__Info .ProductForm__AddToCart');
    $(cart_button).trigger('click');
});

//  subscription cancel/pause text
function productPage(){
   let product_page = document.querySelector('.Product__InfoWrapper');
   if(!product_page) return;
    const appstelInterval = setInterval(function(){
     let appstel_container = document.querySelector('.appstle_sub_widget');
     if(appstel_container){
        $('.custom-two-fields').insertAfter(appstel_container);
        clearInterval(appstelInterval);
      }
    },100);
}
 
productPage();



document.addEventListener('variant:changed', function(event) {
  const start = performance.now();
   updateSubscriptionBadge()
  let variant_id = event.detail.variant.id;
  let variant_price = event.detail.variant.price;
  let compare_at_price = event.detail.variant.compare_at_price;
  let selling_plan_id = event.detail.variant.selling_plan_allocations[0].selling_plan_id;
  let selling_plan_price = event.detail.variant.selling_plan_allocations[0].price;
  let selling_plan_compare_price = event.detail.variant.selling_plan_allocations[0].compare_at_price;
  $('.sticky-add-to-cart').attr('data-variant_id',variant_id);
  // let subscription_radio_btn = $('.appstle_subscription_radio_wrapper input[name="selling_plan"]');
  console.log('selling price:',selling_plan_price, selling_plan_compare_price, compare_at_price)
  let subscription_radio_btn = $('.sls-purchase-options-container input[name="selling_plan"]');
  if ($(subscription_radio_btn).is(':checked')) {
    $('.sticky-add-to-cart').attr('data-selling-plan-id',selling_plan_id);
    $('.sticky-add-to-cart .regular-price').text(Shopify.formatMoney(selling_plan_price));
    $('.sticky-add-to-cart .compare-price').text(Shopify.formatMoney(selling_plan_compare_price));
    $('.ProductForm__AddToCart .regular-price').text(Shopify.formatMoney(selling_plan_price));
    $('.ProductForm__AddToCart .compare-at-price').text(Shopify.formatMoney(selling_plan_compare_price));
  }else{
    $('.sticky-add-to-cart').attr('data-selling-plan-id','');
    $('.sticky-add-to-cart .regular-price').text(Shopify.formatMoney(variant_price));
    $('.sticky-add-to-cart .compare-price').text(Shopify.formatMoney(compare_at_price));
    $('.ProductForm__AddToCart .regular-price').text(Shopify.formatMoney(variant_price));
    $('.ProductForm__AddToCart .compare-at-price').text(Shopify.formatMoney(compare_at_price));    
  }
  $('.ProductForm__BuyButtons .onetime-button .button-price').text(Shopify.formatMoney(variant_price));
  const end = performance.now();

  console.log(`Execution time: ${end - start} ms`);
  productPage();
  // console.log(event.detail,selling_plan_compare_price,selling_plan_price)
});

$(window).scroll(function() {
    var originalButton = $('.ProductForm__AddToCart');
    var stickyButton = $('.sticky-cart');
    if(originalButton.length > 0){
      if ($(window).scrollTop() > originalButton.offset().top) {
          stickyButton.removeClass('hidden');
      } else {
          stickyButton.addClass('hidden');
      }
    }
    
});


// end sticky cart

// $('.Product .flickity-slider .Product__SlideItem img').css( 'cursor', 'url(https://cdn.shopify.com/s/files/1/0645/8248/4045/files/arrow-right-svgrepo-com.png?v=1747977198)' );

const flickity = $('.Product .Product__Slideshows').flickity({
  pageDots: false,
  adaptiveHeight: false,
  wrapAround: true,
  dragThreshold: 10,
   prevNextButtons:false,
});

// 2nd carousel, navigation
$('.Product .Product__SlideshowNavScrollers').flickity({
  asNavFor: '.Product__Slideshows',
  contain: true,
  pageDots: false,
  cellAlign: "left",
  prevNextButtons:false
});

const viewport = document.querySelector('.Product .Product__Slideshows .flickity-viewport');
if(viewport){
document.querySelectorAll('.Carousel__Cell img').forEach(function(img) {
    img.addEventListener('mousemove', function(event) {
      const rect = img.getBoundingClientRect();
      const hoverX = event.clientX - rect.left;

      // Clear both classes first
      viewport.classList.remove('hovering-left', 'hovering-right');

      if (hoverX < rect.width / 2) {
        viewport.classList.add('hovering-left');
      } else {
        viewport.classList.add('hovering-right');
      }
    });

    img.addEventListener('mouseleave', function() {
      viewport.classList.remove('hovering-left', 'hovering-right');
    });

    img.addEventListener('click', function(event) {
      const rect = img.getBoundingClientRect();
      const clickX = event.clientX - rect.left;

      if (clickX < rect.width / 2) {
        flickity.flickity('previous'); 
      } else {
        flickity.flickity('next');
      }
    });
  });
}


// Announcement Bar Clock JS

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    const matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

function getUserTimeZoneOffset() {
    // Get the user's time zone offset in minutes
    return new Date().getTimezoneOffset();
}

if (getCookie('timer') > new Date().getTime()) {
    var time = getCookie('timer');
    var timer = setInterval(function() {
        var left = time - new Date().getTime();
        var hours = Math.floor(left / (1000 * 60 * 60));
        var minutes = Math.floor((left % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((left % (1000 * 60)) / 1000);

        hours = ('0' + hours).slice(-2);
        minutes = ('0' + minutes).slice(-2);
        seconds = ('0' + seconds).slice(-2);

        var hoursElement = document.querySelector('#js-clock-hours');
        var minutesElement = document.querySelector('#js-clock-minutes');
        var secondsElement = document.querySelector('#js-clock-seconds');
        var customLanding  = document.querySelector('.custom-deal-landing');
        
         if(customLanding){
          document.querySelector('.custom-deal-landing strong').innerHTML = `${hours}:${minutes}:${seconds}`;
        }
        if (hoursElement && minutesElement && secondsElement) {
            hoursElement.innerHTML = hours;
            minutesElement.innerHTML = minutes;
            secondsElement.innerHTML = seconds;
        }

        if (left <= 1000) {
            clearInterval(timer);
            document.cookie = 'timer=""; path=/; domain=bleame.com; secure=true; expires=-1';
            location.reload();
        }
    }, 1000); // Changed interval to 1000ms for 1-second updates
} else {
    // Get the current time in the user's local time zone
    var currentTime = new Date();

    // Calculate the time until midnight
    var midnight = new Date(currentTime);
    midnight.setHours(24, 0, 0, 0); // Set to 12:00 AM of the next day

    // Calculate the time remaining until midnight (in milliseconds)
    var timeRemaining = midnight.getTime() - currentTime.getTime();

    // Save the adjusted timer value in the cookie
    document.cookie = 'timer=' + (currentTime.getTime() + timeRemaining) + '; path=/; domain=bleame.com; secure=true; expires=' + new Date(currentTime.getTime() + timeRemaining + 3600000 * 24).toUTCString();

    var timer = setInterval(function() {
        var left = timeRemaining - (new Date().getTime() - currentTime.getTime());
        var hours = Math.floor(left / (1000 * 60 * 60));
        var minutes = Math.floor((left % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((left % (1000 * 60)) / 1000);

        hours = ('0' + hours).slice(-2);
        minutes = ('0' + minutes).slice(-2);
        seconds = ('0' + seconds).slice(-2);

        var hoursElement = document.querySelector('#js-clock-hours');
        var minutesElement = document.querySelector('#js-clock-minutes');
        var secondsElement = document.querySelector('#js-clock-seconds');
        var customLanding  = document.querySelector('.custom-deal-landing strong');
        if(customLanding){
          document.querySelector('.custom-deal-landing strong').innerHTML = `${hours}:${minutes}:${seconds}`;
        }
        if (hoursElement && minutesElement && secondsElement) {
            hoursElement.innerHTML = hours;
            minutesElement.innerHTML = minutes;
            secondsElement.innerHTML = seconds;
        }

        if (left <= 1000) {
            clearInterval(timer);
            document.cookie = 'timer=""; path=/; domain=bleame.com; secure=true; expires=-1';
            location.reload();
        }
    }, 1000); // Changed interval to 1000ms for 1-second updates
}


// Announcement Bar Clock JS Ends



// custom quantity box 
$('.box-content').click(function(){
  let quantity =  $(this).data('quantity');
  $('.box-content').removeClass('active');
  $(this).addClass('active');
  $('input[name="quantity"]').val(quantity);
});


// *** subscription widget ***** //

// $('.onetime-button').click(function(){
//   $('.appstle_one_time_details_wrapper input').trigger('click');
//   let sibl = $(this).siblings('.ProductForm__AddToCart').trigger('click');
//   setTimeout(function(){
//     $('.appstle_subscription_radio_wrapper input').trigger('click');
//   },500)
// });


// *** end of subscription widget ***** //

// hoodi product //

$('.custom-hoodies .custom-varian-size button').click(function(){
    console.log('click');
    jQuery('html').animate({
    scrollTop: jQuery(".Section[data-section-type='product-size-guide']").offset().top - $('.header-sticky').outerHeight()
});
})

